// Hằng số Đánh giá cá nhân (khớp dashboard.constant của app).

export const EVALUATION_STATUS_LABELS = {
  XUAT_SAC: "Xuất sắc",
  DAT: "Đạt",
  CANH_BAO: "Cảnh báo",
  CANH_BAO_DO: "Cảnh báo đỏ",
  CAN_HO_TRO: "Cần hỗ trợ",
  CHUA_XEP_LOAI: "Chưa xếp loại",
};

const EVALUATION_STATUS_UI = {
  XUAT_SAC: { color: "#1277EB", bg: "#DDEDFF" },
  DAT: { color: "#2ABA82", bg: "#EDFDF5" },
  CANH_BAO_DO: { color: "#E5484D", bg: "#FFF1F0" },
  CAN_HO_TRO: { color: "#8B5CF6", bg: "#F5F3FF" },
};

const EVALUATION_STATUS_UI_DEFAULT = { color: "#F79D0D", bg: "#FFF7E8" };

export const getEvaluationStatusLabel = (code) =>
  (code && EVALUATION_STATUS_LABELS[code]) || "Chưa xếp loại";

export const getEvaluationStatusUi = (code) =>
  (code && EVALUATION_STATUS_UI[code]) || EVALUATION_STATUS_UI_DEFAULT;

// Cửa sổ xác nhận: chỉ tháng trước, và chỉ từ ngày mùng 3 (khớp app).
export const getConfirmWindow = () => {
  const now = new Date();
  const prev = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  return {
    prevMonth: prev.getMonth() + 1,
    prevYear: prev.getFullYear(),
    currentMonth: now.getMonth() + 1,
    currentYear: now.getFullYear(),
    isOpen: now.getDate() >= 3,
  };
};

// 4 năm gần nhất cho bộ lọc.
export const buildYearOptions = () => {
  const y = new Date().getFullYear();
  return [y, y - 1, y - 2, y - 3];
};
